// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6df3a52","466":"f0ed4040","901":"aa9f613d"}[chunkId] + ".chunk.js";
};